/**
 * Octopus-owned QuickSight dashboards embedded by Event Hub.
 *
 * The funnel and the registration / attendance actuals are NOT computed by this app —
 * Octopus owns the data and ships it as a dashboard, which is why these are IDs rather
 * than an API call. It is also why TaskOverview has no "Registration Follow-ups" or "MQL
 * Follow-ups" tiles yet, though the design draws them: those numbers never travel through our
 * client.
 *
 * Shared constants rather than inline literals because the same dashboard is reached
 * from two places (the Event Lifecycle Data tab, and historically the debug page's embed
 * smoke test), and a copied GUID that drifts is a page that silently renders someone
 * else's data.
 */

/**
 * Registration / attendee funnel, Octopus account "fast" -- the Event Lifecycle Data tab. Its one
 * sheet ("Eventhub Lifecycle (campaign)") has an Event control plus Campaign Name / Campaign ID
 * controls that narrow to that event's campaigns.
 */
export const REGISTRATION_ATTENDEE_DASHBOARD_ID = 'b120e7c4-aaa9-4ba4-8c44-73ab8dfb668a';
export const REGISTRATION_ATTENDEE_ACCOUNT = 'fast';
export const REGISTRATION_ATTENDEE_SHEET_ID =
  'b120e7c4-aaa9-4ba4-8c44-73ab8dfb668a_7648a74b-825d-42ae-a485-0af6b01a77e6';

/**
 * The same visuals for one event, on the Event Detail page: dashboard "Eventhub Event Detail",
 * sheet "Eventhub Lifecycle (event detail)". It has no Event control; the event comes from
 * {@link EVENT_DETAIL_EVENT_PARAM}, which an "Event ID" control shows and the campaign controls
 * cascade from. A separate dashboard because a QuickSight dropdown cannot show an event's name
 * while being set by its id.
 */
export const EVENT_DETAIL_DASHBOARD_ID = '2ebde00c-5a25-417d-894e-e67619d88e69';
export const EVENT_DETAIL_ACCOUNT = 'fast';
export const EVENT_DETAIL_SHEET_ID =
  '2ebde00c-5a25-417d-894e-e67619d88e69_22576b70-84a5-4b29-a43e-622575ee9b43';
/**
 * Dashboard parameter that narrows the Event Detail sheet to one event. Octopus matches it against
 * the dashboard's event_key, which is the Event Hub eventId of a root event (child events are folded
 * into their root).
 */
export const EVENT_DETAIL_EVENT_PARAM = 'pEventKey';
